module.exports = __webpack_public_path__ + "img/sail-croatia-light.693d7ed2.svg";